import React, {useCallback, useContext, useState} from 'react'
import { CardElement, injectStripe } from 'react-stripe-elements'

import './CheckoutForm.css'
import FirebaseContext from "../../firebase/context";

const cardStyle = {
    base: {
        color: "#32325d",
        fontFamily: 'Montserrat, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "15px",
        "::placeholder": {
            color: "#aab7c4"
        }
    },
    invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
    }
};

const CheckoutForm = ({ stripe, clientSecret, transactionId, paymentKey, onCompleted }) => {
    const firebase = useContext(FirebaseContext);

    const [charging, setCharging] = useState(false);

    const handleSubmit = useCallback(async () => {
        setCharging(true);

        const cardPayment = await stripe.handleCardPayment(clientSecret);

        const callParams = { transactionId, paymentKey, cardPayment };
        const { error } = await firebase.callFunction('validateCompletedPayment', callParams);
        if (error) {
            console.log(`Could not validate payment: ${error}`);
            alert('Błąd walidacji płatności. W razie potrzeby spróbuj ponownie.')
        } else {
            onCompleted();
        }

        setCharging(false);
    }, [firebase, onCompleted, stripe, clientSecret, transactionId, paymentKey]);

    return (
        <React.Fragment>
            <CardElement className="MyCardElement" style={cardStyle} />
            <button
                className="CheckoutForm-button"
                onClick={() => !charging && handleSubmit()}
            >
                {charging ? 'Transakcja w trakcie...' : 'Wykonaj płatność'}
            </button>
        </React.Fragment>
    )
};

export default injectStripe(CheckoutForm);
